import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/megapack';
import { SectionHeading } from './SectionHeading';
import { useReveal } from '../hooks/useReveal';
export function BonosSection() {
  const gridRef = useReveal<HTMLDivElement>();
  return <section id="bonos" className="w-full bg-forest-50 px-5 py-16 sm:py-20" aria-labelledby="bonos-title" data-id="element-22" data-mp="13bl0syfatuq6">
      <div className="mx-auto max-w-5xl" data-id="element-23" data-mp="tfqb5jcnqzdw">
        <div className="text-center" data-id="element-24" data-mp="tgj9bvxjwgkf">
          <GiftIcon className="mx-auto h-9 w-9 text-blush-500" aria-hidden="true" data-id="element-25" data-mp="tddjgeh3lann" />
        </div>
        <div className="mt-4" data-id="element-26" data-mp="oirfgwdcikdl">
          <SectionHeading id="bonos-title" eyebrow="Incluidos sin costo extra" title={<>
                Los <span className="mark-pink" data-id="element-28" data-mp="fgi8uhl77b5h">5 Bonos Especiales</span> Gratis
              </>} subtitle="Cinco materiales extra que se suman al MegaPack, sin pagar nada más." data-id="element-27" data-mp="kejpywz2d0eb" />
        </div>

        <div ref={gridRef} className="reveal-group mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-29" data-mp="29tzwe4lls80i">
          {bonos.map((bono, index) => <article key={bono.id} style={{
          transitionDelay: `${index % 3 * 60}ms`
        }} className="reveal flex flex-col overflow-hidden rounded-3xl border-2 border-forest-100 bg-white shadow-card transition-colors duration-300 hover:border-blush-100" data-id="element-30" data-mp="qv4twegpgb6t" data-mpi={index}>
              <div className="relative bg-cream p-4" data-id="element-31" data-mp="mtt0ryymh7tv">
                <img src={bono.image} alt={`Mockup del bono ${bono.title}`} width={1240} height={1240} sizes="(min-width: 1024px) 320px, (min-width: 640px) 45vw, 90vw" loading="lazy" decoding="async" className="h-56 w-full rounded-2xl object-cover object-center" data-id="element-32" data-mp="muclfnfnqabl" />
                <span className="absolute left-6 top-6 rounded-full bg-forest-800 px-2.5 py-1 font-display text-[10px] font-extrabold uppercase tracking-wider text-cream" data-id="element-33" data-mp="10udnh67nrnsn">
                  {bono.number}
                </span>
                <span className="absolute right-6 top-6 rounded-full bg-lime-500 px-2.5 py-1 font-display text-[10px] font-extrabold uppercase tracking-wider text-forest-900" data-id="element-34" data-mp="1thhnsxvt3dy3">
                  Gratis
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5 pt-3" data-id="element-35" data-mp="235vkh8y6kgvr">
                <h3 className="font-display text-lg font-extrabold leading-snug text-forest-800" data-id="element-36" data-mp="236er3tidriuh">
                  {bono.title}
                </h3>
                <p className="mt-2 text-[13px] leading-relaxed text-forest-900/75" data-id="element-37" data-mp="1t7xuoh0oac11">
                  {bono.description}
                </p>
                <p className="mt-2 font-hand text-base text-forest-400" data-id="element-38" data-mp="1p7ngih2q8fb3">{bono.ideal}</p>

                <p className="mt-auto pt-4 text-[11px] font-bold uppercase tracking-wider text-forest-900/45" data-id="element-39" data-mp="1kely3z3b9xmr">
                  Valor: <span className="line-through" data-id="element-40" data-mp="1fgkftgdpm2cc">{bono.value}</span>{' '}
                  <span className="text-lime-600" data-id="element-41" data-mp="1ai94f17rnjs0">→ hoy gratis</span>
                </p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-12 max-w-md rounded-3xl border-2 border-gold-400 bg-gold-100 p-7 text-center shadow-card" data-id="element-42" data-mp="15k7kyf6fhig0">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-forest-700" data-id="element-43" data-mp="3d4518uewf66m">
            Valor total de los 5 bonos
          </p>
          <p className="mt-1 font-display text-3xl font-extrabold text-forest-900/50 line-through" data-id="element-44" data-mp="3h3vq2skv7c8i">
            ARS 40.750
          </p>
          <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[0.2em] text-forest-700" data-id="element-45" data-mp="3r3mjeqxovl70">
            Tu precio hoy
          </p>
          <p className="mt-1 font-display text-5xl font-extrabold text-forest-800" data-id="element-46" data-mp="2tgxadx4kk8bn">GRATIS</p>
          <p className="mt-3 font-hand text-xl text-forest-700" data-id="element-47" data-mp="2ye76twqdlk8z">Solo incluidos en esta oferta.</p>
        </div>
      </div>
    </section>;
}